/** True when running inside the Flutter AX-App WebView (class injected on load). */
export function isAxAppWebView(): boolean {
  return document.documentElement.classList.contains('ax-app-webview');
}
